import { type Agent, balanceOf as agentBalanceOf, rewardsPendingOf as agentRewardsPendingOf } from "../agentsMocks";
import { type Holder, balanceOf as holderBalanceOf, rewardsPendingOf as holderRewardsPendingOf } from "../holdersMocks";

import type { Participant } from "./ParticipantRow";

/** Normalize an agent to the `Participant` shape a `ParticipantRow` renders. */
export function agentToParticipant(agent: Agent, onNavigate: () => void): Participant {
    return {
        id: agent.id,
        name: agent.name,
        eligibility: agent.eligibility,
        balance: agentBalanceOf(agent),
        earned: agent.rewards,
        pending: agentRewardsPendingOf(agent),
        onNavigate
    };
}

/** Normalize a holder to the `Participant` shape a `ParticipantRow` renders. */
export function holderToParticipant(holder: Holder, onNavigate: () => void): Participant {
    return {
        id: holder.id,
        name: holder.name,
        eligibility: holder.eligibility,
        balance: holderBalanceOf(holder),
        earned: holder.rewards,
        pending: holderRewardsPendingOf(holder),
        onNavigate
    };
}
